<template>
    <v-container class="p-relative">
        <v-row>
            <v-col cols="12">
                <v-img :src="imgPlaceholder" max-width="120" class="mx-auto"/>
            </v-col>
            <v-col cols="12" class="title-mail">
                {{ $t('entrance.confirm_email') }}
            </v-col>
            <v-col cols="12" class="subtitle">
                {{ $t('entrance.step_for_confirm_email') }}
            </v-col>
        </v-row>

        <v-row class="container-bottom">
            <v-col cols="12">
                <logout-button outlined color="black" large block/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LogoutButton from "@/components/common/inputs/LogoutButton";

export default {
    components: {LogoutButton},
}
</script>

<style scoped>

.title-mail {
    display: inline-block;
    font-size: 30px;
    line-height: 35px;
    font-weight: bold;
    color: #078571;
}

.subtitle {
    font-size: 20px;
    color: #707070;
}

.container-bottom {
    position: sticky;
    bottom: 0;
    margin-top: 4px;
}

</style>